/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SeriesWithRelations } from '../../models/series-with-relations';

export interface AdminGetSeries$Params {
  inventoryId: string;
  lang?: string;
}

export function adminGetSeries(http: HttpClient, rootUrl: string, params: AdminGetSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SeriesWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetSeries.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SeriesWithRelations>>;
    })
  );
}

adminGetSeries.PATH = '/admin/inventories/{inventoryId}/series';
